/* Quiz „Dobierz za mnie” (spec 7.10.2026). Preference matching only: answers stay in page memory. */
(() => {
  const H = {
    rest:'glow-up-rest-gleboki-sen-i-odnowa-100-kapsulek', balance:'glow-up-balance-odpornosc-na-stres-i-presje-100-kapsulek',
    drive:'suplement-drive-shbg-booster', shield:'glowup-shield-detoks-i-regeneracja-60-kapsulek', serce:'suplement-na-serce',
    mind:'glowup-mind-soplowka-jezowata', synapse:'glowup-synapse-chaga', zen:'glowup-zen-reishi',
    nocny:'protokol-nocny-reset', dzienNoc:'protokol-dzien-noc', longevity:'protokol-dlugowiecznosc-longevity',
    system:'protokol-system-24-7', pelna:'protokol-pelna-optymalizacja'
  };
  // Label data from product pages. days = daily portions per package.
  const SPECS = {
    rest:{days:100, composition:['L-tryptofan – 500 mg']},
    balance:{days:100, composition:['Ekstrakt z korzenia ashwagandhy KSM-66® – 200 mg, w tym witanolidy – 10 mg']},
    drive:{days:60, composition:['L-tyrozyna – 500 mg','Ekstrakt z ashwagandhy, w tym witanolidy – 100 mg','Cynk – 15 mg','Bor – 3 mg']},
    shield:{days:60, composition:['Ekstrakt z ostropestu plamistego – 200 mg, w tym sylimaryna – 140 mg']},
    serce:{days:30, composition:['Ekstrakt z pestek grejpfruta – 500 mg','Ekstrakt z czosnku – 500 mg','Ekstrakt z rdestowca japońskiego – 100 mg','Koenzym Q10 – 100 mg']},
    mind:{days:50, composition:['Ekstrakt z soplówki jeżowatej 10:1 – 200 mg / 1 ml, w tym polisacharydy – 40 mg']},
    synapse:{days:50, composition:['Ekstrakt z chagi – 200 mg / 1 ml, w tym polisacharydy – 40 mg']},
    zen:{days:50, composition:['Ekstrakt z reishi – 200 mg / 1 ml, w tym polisacharydy – 40 mg']}
  };
  // ponytail: Pełna Optymalizacja = System 24/7 + Na Serce, inferred from price; confirm with the product team.
  const BUNDLES = {nocny:['balance','rest'], dzienNoc:['drive','balance'], longevity:['serce','shield'],
    system:['drive','shield','balance','rest'], pelna:['drive','shield','balance','rest','serce']};
  // Rows = Q1 area, columns = Q4 start. Mushroom trio doesn't exist yet, so its set falls back to MIND.
  const PLAN = {
    evening:{set:'nocny', single:'rest', full:'system'},
    day:{set:'dzienNoc', single:'drive', full:'system'},
    mind:{set:'mind', single:'mind', full:'system'},
    heart:{set:'longevity', single:'serce', full:'pelna'}
  };
  const SINGLES = ['rest','shield','mind','synapse','zen','serce','balance','drive'];
  const LABELS = {
    area:{evening:'Wieczorna rutyna', day:'Aktywny dzień', mind:'Praca umysłowa', heart:'Serce – codzienna rutyna'},
    training:{none:'Nie trenuję', some:'1–2 razy w tygodniu', often:'3 razy w tygodniu lub częściej'},
    day:{desk:'Głównie przy biurku', move:'Głównie w ruchu', mixed:'Różnie'},
    start:{set:'Zestaw', single:'Jeden produkt', full:'Pełny protokół'}
  };

  const parts = key => BUNDLES[key] || [key];
  const contains = (main, key) => main === key || parts(main).includes(key);

  function neighbour(area, start, taken) {
    const order = start === 'set' ? ['single','full'] : ['set','single'];
    for (const level of order) { const key = PLAN[area][level]; if (!taken.includes(key)) return key; }
    return ['synapse','zen','mind'].find(k => !taken.includes(k));
  }

  /** Pure selection: answers + catalog (keyed by internal key) + cart total in grosze → result keys. */
  function choose(answers, catalog, opts = {}) {
    const {area, training, day, start} = answers;
    const cartTotal = opts.cartTotal || 0, thresholds = opts.thresholds || [20000, 30000];
    const main = PLAN[area][start];
    let alt = training === 'some' ? 'drive' : training === 'often' ? 'dzienNoc' : null;
    if (!alt || contains(main, alt)) alt = neighbour(area, start, [main]);

    const price = key => catalog[key]?.price ?? Infinity;
    const base = cartTotal + price(main);
    const closer = () => {
      const target = thresholds.find(t => t > base);
      const byPrice = SINGLES.filter(k => !contains(main, k) && !contains(alt, k) && catalog[k]?.available)
        .sort((a, b) => price(a) - price(b));
      if (!target) return byPrice[0];
      return byPrice.find(k => base + price(k) >= target) || byPrice[byPrice.length - 1];
    };
    let addon = day === 'desk' ? 'mind' : day === 'move' ? 'shield' : null;
    if (!addon || contains(main, addon) || contains(alt, addon)) addon = closer();
    return {main, alt, addon};
  }

  function separately(key, catalog) {
    const list = BUNDLES[key];
    if (!list || list.some(k => !catalog[k])) return null;
    return list.reduce((sum, k) => sum + catalog[k].price, 0);
  }

  function composition(key) { return parts(key).flatMap(k => (BUNDLES[key] ? [k.toUpperCase() + ':'] : []).concat(SPECS[k].composition)); }
  function days(key) { return Math.min(...parts(key).map(k => SPECS[k].days)); }

  if (typeof module !== 'undefined' && module.exports) { module.exports = {choose, PLAN, BUNDLES, separately, H}; return; }

  const money = cents => new Intl.NumberFormat('pl-PL', {style:'currency', currency:'PLN'}).format(cents / 100);
  const el = (tag, text, cls) => { const n = document.createElement(tag); if (text) n.textContent = text; if (cls) n.className = cls; return n; };

  document.querySelectorAll('[data-product-quiz]').forEach(root => {
    const raw = JSON.parse(root.querySelector('[data-quiz-catalog]').textContent);
    const catalog = {};
    for (const [key, handle] of Object.entries(H)) { const p = raw.find(x => x.handle === handle); if (p) catalog[key] = p; }
    const drawer = document.querySelector('cart-drawer');
    const shipping = Number(drawer?.dataset.freeShipping) || 20000;
    const giftOn = drawer?.dataset.giftEnabled === 'true';
    const gift = Number(drawer?.dataset.giftThreshold) || 30000;
    const thresholds = giftOn ? [shipping, gift] : [shipping];

    const form = root.querySelector('[data-quiz-form]'), steps = [...root.querySelectorAll('[data-quiz-step]')];
    const back = root.querySelector('[data-quiz-back]'), submit = root.querySelector('[data-quiz-next]');
    const progress = root.querySelector('.quiz-progress'), loading = root.querySelector('[data-quiz-loading]');
    const results = root.querySelector('[data-quiz-results]'), intro = root.querySelector('[data-quiz-intro]');
    let step = 0, cartTotal = 0;

    function show(index, focus = true) {
      step = index;
      steps.forEach((s, i) => { s.hidden = i !== index; });
      back.hidden = index === 0;
      submit.hidden = index !== steps.length - 1;
      submit.disabled = !steps[index].querySelector('input:checked');
      root.querySelector('[data-quiz-progress]').textContent = `Krok ${index + 1} z ${steps.length}`;
      const meter = root.querySelector('[data-quiz-meter]'); meter.value = index + 1; meter.textContent = `${index + 1} / ${steps.length}`;
      if (focus) { const legend = steps[index].querySelector('legend'); legend.tabIndex = -1; legend.focus(); }
    }

    const answers = () => Object.fromEntries(['area','training','day','start'].map(n => [n, form.querySelector(`input[name="${n}"]:checked`)?.value]));

    async function cartNow() {
      try { const r = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', {headers:{Accept:'application/json'}}); return (await r.json()).total_price || 0; }
      catch (_) { return 0; }
    }
    function barText(total) {
      const next = thresholds.find(t => t > total);
      if (!next) return giftOn ? 'Masz darmową dostawę i shaker gratis.' : 'Masz darmową dostawę.';
      return `Do ${next === shipping ? 'darmowej dostawy' : 'shakera gratis'} brakuje ${money(next - total)}`;
    }
    // Same markup as the cart drawer bar, so it looks and reads the same.
    const bar = el('div', null, 'free-shipping-bar quiz-bar'), barLabel = el('p', null, 'free-shipping-bar__label');
    const barTrack = el('div', null, 'free-shipping-bar__progress'), barFill = el('div', null, 'free-shipping-bar__fill');
    barTrack.append(barFill); bar.append(barLabel, barTrack);
    function setBar(total) {
      const next = thresholds.find(t => t > total);
      barLabel.textContent = barText(total);
      barFill.style.width = `${next ? Math.round(total / next * 100) : 100}%`;
    }
    async function refreshBar() { setBar(await cartNow()); }

    function addButton(label, key, quantity = 1, cls = 'btn btn--primary btn--full') {
      const b = el('button', label, cls); b.type = 'button';
      b.addEventListener('click', async () => { if (await window.NutriCart.add({items:[{id:catalog[key].id, quantity}]}, b)) refreshBar(); });
      return b;
    }

    // Price colours follow snippets/price.liquid: promo and protocols red, Na Serce gold.
    const onSale = p => p.compare > p.price && p.lowest > p.price;
    function price(key, cls) {
      const p = catalog[key], box = el('div', null, `quiz-price ${cls || ''}`);
      const tone = onSale(p) || BUNDLES[key] ? ' is-sale' : key === 'serce' ? ' is-gold' : '';
      box.append(el('span', money(p.price), 'quiz-price__current' + tone));
      if (onSale(p)) {
        const was = el('s', money(p.compare), 'quiz-price__regular');
        box.append(was, el('span', `Najniższa cena z 30 dni przed obniżką: ${money(p.lowest)}`, 'quiz-price__omnibus'));
      }
      return box;
    }

    function card(key, kind) {
      const p = catalog[key], c = el('article', null, `quiz-result quiz-result--${kind}`);
      if (p.image) {
        const media = el('div', null, 'quiz-result__media'), img = el('img');
        img.src = p.image; img.alt = p.title; img.loading = 'lazy'; img.width = 600; img.height = 600;
        media.append(img); c.append(media);
      }
      const body = el('div', null, 'quiz-result__body'), head = el('div', null, 'quiz-result__head');
      head.append(el(kind === 'main' ? 'h3' : 'h4', p.title, 'quiz-result__title'), price(key));
      const sep = separately(key, catalog), meta = el('p', null, 'quiz-result__meta');
      meta.textContent = `${money(Math.round(p.price / days(key)))} dziennie · opakowanie na ${days(key)} dni`
        + (sep && sep > p.price ? ` · kupowane osobno ${money(sep)}` : '');
      head.append(meta);
      body.append(head);
      if (kind === 'main') {
        const comp = el('div', null, 'quiz-result__composition'), ul = el('ul');
        comp.append(el('p', 'Skład dziennej porcji', 'quiz-result__composition-label'));
        composition(key).forEach(line => ul.append(el('li', line, line.endsWith(':') ? 'quiz-result__composition-head' : '')));
        comp.append(ul); body.append(comp);
        if (giftOn && p.price >= gift) body.append(el('p', '+ shaker gratis do tego zamówienia', 'quiz-result__gift'));
      }
      const actions = el('div', null, 'quiz-result__actions');
      if (!p.available) actions.append(el('p', 'Chwilowo niedostępny', 'quiz-error'));
      else if (kind === 'main') {
        actions.append(addButton('DODAJ DO KOSZYKA', key));
        // Pack discount from scripts/omnibus.py: -15% (-10% on promo), taken once per order.
        const pct = onSale(p) ? 10 : 15;
        if (key === 'serce') actions.append(addButton(`DWUPAK -${pct}% · ${money(2 * p.price - Math.round(2 * p.price * pct / 100))}`, key, 2, 'btn btn--ghost btn--full'));
      } else actions.append(addButton('DODAJ DO KOSZYKA', key, 1, 'btn btn--ghost'));
      const link = el('a', 'Zobacz skład i ostrzeżenia', 'quiz-result__link'); link.href = p.url;
      actions.append(link);
      body.append(actions);
      if (kind === 'main') body.append(bar);
      c.append(body);
      return c;
    }

    function render() {
      const a = answers(), result = choose(a, catalog, {cartTotal, thresholds});
      root.querySelector('[data-quiz-summary]').replaceChildren(
        ...['area','training','day','start'].map(n => el('li', LABELS[n][a[n]])));
      root.querySelector('[data-quiz-main]').replaceChildren(catalog[result.main] ? card(result.main, 'main') : el('p', 'Ten produkt jest chwilowo niedostępny. Sprawdź katalog.'));
      const projected = cartTotal + (catalog[result.main]?.price || 0);
      setBar(projected);

      const addonSlot = root.querySelector('[data-quiz-addon]'), ad = catalog[result.addon];
      addonSlot.replaceChildren();
      root.querySelector('[data-quiz-addon-section]').hidden = !ad;
      if (ad) {
        const row = el('div', null, 'quiz-addon');
        if (ad.image) { const img = el('img'); img.src = ad.image; img.alt = ad.title; img.width = 96; img.height = 96; img.loading = 'lazy'; row.append(img); }
        const info = el('div', null, 'quiz-addon__info');
        info.append(el('strong', ad.title, 'quiz-addon__name'), price(result.addon, 'quiz-price--sm'));
        const crossed = thresholds.find(t => projected < t && projected + ad.price >= t);
        if (crossed) info.append(el('span', crossed === shipping ? 'Z tym produktem: darmowa dostawa' : 'Z tym produktem: shaker gratis', 'quiz-addon__perk'));
        row.append(info, ad.available ? addButton('+ DODAJ', result.addon, 1, 'btn btn--ghost') : el('span', 'Niedostępny', 'quiz-addon__perk'));
        addonSlot.append(row);
      }
      root.querySelector('[data-quiz-alt-section]').hidden = !catalog[result.alt];
      root.querySelector('[data-quiz-alt]').replaceChildren(...(catalog[result.alt] ? [card(result.alt, 'alt')] : []));
    }

    // Steps 1–3 advance on click; step 4 waits for the button (spec: "Przycisk tylko na ostatnim kroku").
    // 'click' (not 'change') so re-picking the same answer after WSTECZ still advances.
    form.addEventListener('click', e => {
      if (!e.target.matches('input[type="radio"]')) return;
      if (step < steps.length - 1) show(step + 1);
      else submit.disabled = false;
    });
    form.addEventListener('submit', async e => {
      e.preventDefault();
      if (!steps[step].querySelector('input:checked')) return;
      form.hidden = true; progress.hidden = true; intro.hidden = true; loading.hidden = false;
      [cartTotal] = await Promise.all([cartNow(), new Promise(r => setTimeout(r, 1200))]);
      render();
      loading.hidden = true; results.hidden = false;
      root.querySelector('[data-quiz-result-heading]').focus();
    });
    back.addEventListener('click', () => show(step - 1));
    root.querySelector('[data-quiz-restart]').addEventListener('click', () => {
      form.reset(); form.hidden = false; results.hidden = true; progress.hidden = false; intro.hidden = false; show(0);
      root.scrollIntoView({block: 'start'});
    });
    show(0, false);
  });
})();
